// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_g2-0";
export var actionModalContentContainer = "_g2-1";
export var createTagButton = "_g2-2";
export var footerContainer = "_g2-7";
export var fullWidthDivider = "_g2-3";
export var hasCreateTagButton = "_g2-4";
export var noCreateTagButton = "_g2-5";
export var tagsContainer = "_g2-6";
export var tagsModalContentContainer = "_g2-8";